(() => {
  const prepareLink = (event) => {
    const link = event.target.closest?.('[data-product-quote-link]');
    if (!link) return;
    const product = link.closest('product-info');
    if (!product) return;
    try {
      const variant = JSON.parse(product.querySelector('[data-selected-variant]')?.textContent || 'null');
      const url = new URL(link.href, window.location.origin);
      if (variant?.id) {
        url.searchParams.set('variant', String(variant.id));
        url.searchParams.set('variant_title', variant.title || '');
      }
      const quantity = product.querySelector('input[name="quantity"]')?.value;
      if (/^[1-9]\d{0,8}$/.test(quantity || '')) url.searchParams.set('quantity', quantity);
      else url.searchParams.delete('quantity');
      url.searchParams.set('source', window.location.pathname);
      link.href = url.toString();
    } catch {}
  };
  ['click', 'auxclick', 'contextmenu'].forEach((type) => document.addEventListener(type, prepareLink, true));
})();
